import logger from '../../utils/logger';
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import LoadingSpinner from '../common/LoadingSpinner';
import { isAdmin } from '../../utils/adminUtils';

const ProtectedRoute = ({ children, requireAdmin = false }) => {
  const { isAuthenticated, loading, user } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-100">
        <LoadingSpinner size="lg" color="gray" />
      </div>
    );
  }

  if (!isAuthenticated()) {
    return <Navigate to="/auth" replace />;
  }

  // Admin-only routes: send non-admins home rather than leaking the page shell
  if (requireAdmin && !isAdmin(user)) {
    logger.warn('Blocked non-admin access to admin-only route');
    return <Navigate to="/home" replace />;
  }

  return children;
};

export default ProtectedRoute;